import {useMsal} from "@azure/msal-react";

export const HomePage = () => {
    const {accounts} = useMsal();
    
    return (<p>Hello {accounts[0].name}</p>);
}